import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {useParams} from 'react-router-dom';
import {HistorySingleVoyageLazy} from "@containers/singleVoyage/historyVoyage/HistorySingleVoyage.lazy";
import {
    useGetInitialAccountIdSingleVoyage
} from "@containers/singleVoyage/account/hooks/useGetInitialAccountIdSingleVoyage";

const HistorySingleVoyagePage = () => {

    const {voyageId} = useParams()

    const accountId = useGetInitialAccountIdSingleVoyage()

    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <HistorySingleVoyageLazy
                    accountId={accountId}
                    voyageId={voyageId}
                />
            </Suspense>
        </PageLayout>
    );
};

export default HistorySingleVoyagePage;